define('datakit/collection',['require','exports','module','marionette','backbone','underscore','./util/url','./ajax','./mixin/fetched.flag.mixin','./util/enable.relationship.lazy.loading'],function(require, exports, module){
  var Mn                            = require('marionette');
  var Backbone                      = require('backbone');
  var _                             = require('underscore');
  var url                           = require('./util/url');
  var ajax                          = require('./ajax');
  var FetchedFlagMixin              = require('./mixin/fetched.flag.mixin');
  var enableRelationshipLazyLoading = require('./util/enable.relationship.lazy.loading');

  var Collection = Backbone.Collection.extend(FetchedFlagMixin).extend({

    initialize: function(models, options) {
      Backbone.Collection.prototype.initialize.apply(this, arguments);
      options = options || {};

      FetchedFlagMixin.initializeMixin.call(this, {}, options);

      this._adapters = [];
      
      var urlParamDefaults = _.extend(
        {},
        Mn._getValue(this.urlParamDefaults, this),
        Mn._getValue(options.urlParamDefaults, this)
      );
      this._urlParams = new Backbone.Model(urlParamDefaults);

      if (options.urlTemplate) {
        this.urlTemplate = options.urlTemplate;
      }

      this.on('sync', function() {
        enableRelationshipLazyLoading(this);
      });
    },

    url: function() {
      return url.template(this.urlTemplate || '', this._urlParams);
    },

    clearUrlTemplate: function() {
      delete this.urlTemplate;
      return this;
    },

    setUrlTemplate: function(urlTemplate) {
      this.urlTemplate = urlTemplate;
      return this;
    },

    clearUrlParams: function() {
      this._urlParams.clear();
      return this;
    },

    urlParams: function() {
      this._urlParams.set.apply(this._urlParams, arguments);
      return this;
    },

    addAdapter: function(adapter) {
      if (adapter) {
        this._adapters.push(adapter);
        if (_.isFunction(adapter.setup)) {
          adapter.setup(this);
        }
      }
      return this;
    },

    clearAdapters: function() {
      _.invoke(this._adapters, 'destroy');
      this._adapters = [];
      return this;
    },

    fetch: function(options) {
      options = _.extend({ useAdapters: true }, options);
      return Backbone.Collection.prototype.fetch.call(this, options);
    },

    sync: function(method, collection, options) {
      var adapters   = collection._adapters,
          error      = null,
          success    = null;

      options.parse = false;

      options = _.extend({}, options);

      if (options.useAdapters) {
        _.invoke(adapters, 'preprocess', options);
      }

      success = options.success;
      options.success = function(resp) {
        var data = collection.parse(resp);
        if (options.useAdapters) {
          data = collection.mutateResponseThroughAdapters(data, resp);
        }
        if (success && resp !== false) success(data);
      }

      error = options.error;
      options.error = function(xhr, textStatus, err) {
        if (options.useAdapters) {
          _.invoke(adapters, 'error', err);
        }
        if (error) error(xhr, textStatus, err);
      }

      return Backbone.sync.call(this, method, collection, options);
    },

    mutateResponseThroughAdapters: function(data, resp) {
      for (var i = 0, len = this._adapters.length, adapter; i < len; i++) {
        adapter = this._adapters[i];
        if (_.isFunction(adapter.postprocess)) {
          adapter.postprocess(data, resp);
        }
        if (_.isFunction(adapter.filter)) {
          data = adapter.filter(data, resp);
        }
      }

      return data;
    }

  });

  module.exports = Collection;
});

